import moment from "moment";

export const sortByUpdatedDate = (a: any, b: any) => {
  if (moment(a.updatedAt).isAfter(moment(b.updatedAt))) {
    return -1;
  } else {
    return 1;
  }
};
